import PropTypes from 'prop-types';

import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import Info from '../Info';
import StyledTextField from '../Shared/StyledTextField';

const TextFieldComponent = (props) => {
  const theme = useTheme();
  const {
    input,
    meta: { touched, error, active },
    disabled,
    fieldNotes,
    characterLimit,
    ...custom
  } = props;

  const characterInfo = `${input?.value?.length}/${characterLimit}`;
  const helperText = (
    <Box display="flex" position="relative">
      <Box maxWidth="80%">{touched && error}</Box>
      {active && characterLimit && (
        <Box color={theme.palette.text.secondary} position="absolute" right="0">
          {characterInfo}
        </Box>
      )}
    </Box>
  );

  return (
    <>
      {fieldNotes && active && <Info>{fieldNotes}</Info>}
      <StyledTextField
        FormHelperTextProps={{
          component: 'div',
        }}
        helperText={helperText}
        error={touched && !!error}
        maxRows={5}
        disabled={!!disabled}
        inputProps={{
          maxLength: characterLimit ?? Number.MAX_SAFE_INTEGER,
        }}
        {...input}
        {...custom}
      />
    </>
  );
};

TextFieldComponent.propTypes = {
  input: PropTypes.instanceOf(Object).isRequired,
  meta: PropTypes.instanceOf(Object).isRequired,
  disabled: PropTypes.bool,
  fieldNotes: PropTypes.string,
  characterLimit: PropTypes.number,
};

export default TextFieldComponent;
